export { Smartband } from './smartband/impl/mock';
